import { Segmented } from 'antd';
import { t, toEnglish } from '../../i18n/i18n';
import './SegmentedTabs.scss';

/** Labels shown translated; the value handed to `onChange` stays as given. */
const translateOption = (option) => {
  if (typeof option === 'string') return { label: t(toEnglish(option)), value: option };
  if (option && typeof option === 'object' && typeof option.label === 'string') {
    return { ...option, label: t(toEnglish(option.label)) };
  }
  return option;
};

export default function SegmentedTabs({
  options,
  value,
  onChange,
  radius = 'control',
  size,
  className = '',
  ...rest
}) {
  return (
    <Segmented
      {...rest}
      options={options?.map(translateOption)}
      value={value}
      onChange={onChange}
      className={`ac-seg ac-seg--${radius}${size ? ` ac-seg--${size}` : ''} ${className}`.trim()}
    />
  );
}
